import { render, staticRenderFns } from "./ShareRoads.vue?vue&type=template&id=70592699&scoped=true&"
import script from "./ShareRoads.vue?vue&type=script&lang=js&"
export * from "./ShareRoads.vue?vue&type=script&lang=js&"
import style0 from "./ShareRoads.vue?vue&type=style&index=0&id=70592699&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70592699",
  null
  
)

export default component.exports